import gql from 'graphql-tag'

// USED IN: SCHEDULE, PATIENT_NOTES, VEIL, ACTION_STREAM
export const GetAllNotes = gql`
  query GetAllNotes($ids: [ID!], $userId: ID, $patientId: ID, $limit: Int, $offset: Int) {
    allNotes(input: {
      ids: $ids,
      userId: $userId,
      patientId: $patientId,
      limit: $limit,
      offset: $offset
    }) {
      count,
      results {
        # If it's a composition
        ... on Composition {
          id,
          metadata {
            status,
            partialDictation {
              partialDictationComposition,
              readOnly
            }
            user {
              id,
              person {
                firstName,
                middleName,
                lastName,
                prefix,
                suffix
              },
              userType
            },
            appointment {
              id,
              startsAt
            },
            submissionInformation {
              destinations,
              tryAllDestinations
            },
            submissionStatus {
              warning {
                type,
                message
              },
              finalDestination
            },
            clientType
            createdWithS2
          },
          createdAt
        },
        # If it's a patient note
        ... on PatientNote {
          noteId,
          compositionId,
          metadata {
            status,
            partialDictation {
              partialDictationComposition,
              readOnly
            }
            user {
              id,
              person {
                firstName,
                middleName,
                lastName,
                prefix,
                suffix
              },
              userType
            },
            appointment {
              id,
              startsAt
            },
            submissionInformation {
              destinations,
              tryAllDestinations
            },
            submissionStatus {
              warning {
                type,
                message
              },
              finalDestination
            },
            clientType
            createdWithS2
          }
          compositionCreatedAt
        }
      }
    }
  }
`

export const GetNotesByUserId = gql`
  query GetAllNotes($userId: ID) {
    allNotes(input: {
      userId: $userId,
    }) {
      count,
      results {
        ... on Composition {
          metadata {
            status
          }
        },
        ... on PatientNote {
          metadata {
            status
          }
        }
      }
    }
  }
`

// USED IN: VEIL
export const GetPatientNoteById = gql`
  query GetPatientNoteById($id: ID!) {
    patientNotes(input: { ids: [$id] }) {
      count,
      results {
        noteId,
        compositionId,
        metadata {
          name,
          status,
          noteTypeId,
          appointment {
            id,
            startsAt,
            reason
          },
          patient {
            id,
            person {
              firstName,
              middleName,
              lastName,
              dateOfBirth,
              gender,
              prefix,
              suffix
            },
            mrn
          },
          user {
            id,
            person {
              firstName,
              lastName,
              middleName
            }
          },
          submissionInformation {
            destinations,
            tryAllDestinations
          },
          submissionStatus {
            warning {
              type,
              message
            },
            finalDestination
          },
          clientType,
          createdWithS2,
        },
        sections {
          id,
          name,
          content,
          navigationKeywords,
          status,
          cursors {
            actor,
            location
          }
          diagnosisEntry {
            diagnosis {
              icdCode
              billable
              snomedCode
              description
              snomedDescription
              problemLabel
              hccCode
              panelRanking
              suggestionType
            }
            detailedDisplay {
              tags {
                text
              }
            }
            confirmStatus
          }
          pbcSectionFlag
        },
        compositionCreatedAt
      }
    }
  }
`
